module.exports = __webpack_public_path__ + "static/media/fnb&Standard.8ec5778e.png";